import React from 'react';

import LinksPageLayout
  from 'components/dashboard/links-content/links-layout/LinksPageLayout';
import MenuPageContent from 'components/dashboard/menu-links-content/MenuPageContent';


const DashboardMenuLinksPage = () => (
  <LinksPageLayout activeLinksPage="menu">
    <MenuPageContent />
  </LinksPageLayout>
);

export default DashboardMenuLinksPage;